// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import { orderNumberHeading } from "@store/Themes/common/props/checkout";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const cartState = getCartState(state, state.pages.orderConfirmation.cartId);
    return {
        cart: cartState.value,
        linkedCart: cartState.value?.properties.linkedCarts
            ? getCartState(state, cartState.value.properties.linkedCarts).value
            : null,
    };
};

export interface OrderConfirmationHeadingStyles {
    orderNumberHeading?: TypographyProps;
    orderNumberText?: TypographyPresentationProps;
    orderSplitText?: TypographyPresentationProps;
    orderSplitOrderNumberText?: TypographyPresentationProps;
}

export const orderConfirmationHeadingStyles: OrderConfirmationHeadingStyles = {
    orderNumberHeading: {
        as: "h2",
        ...orderNumberHeading,
    },
    orderSplitText: {
        css: css`
            display: block;
            padding-top: ${pxToRem(16)};
            ${({ theme }) => `
                font-family: ${theme.design.typography.fontFamily.base};
                font-weight: ${theme.design.typography.weight.base};
                font-size: ${theme.design.typography.size.base};
                line-height: ${theme.design.typography.lineHeight.base};
            `}
        `,
    },
    orderSplitOrderNumberText: {
        variant: "h4",
        forwardAs: "h3",
    },
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = orderConfirmationHeadingStyles;
const OrderConfirmationHeading = ({ cart, linkedCart }: Props) => {
    if (!cart) {
        return null;
    }

    const hasProgramItems = linkedCart ?? false;

    return (
        <>
            <Typography {...styles.orderNumberHeading}>
                {hasProgramItems ? `${translate("Thank you for your order")}` : `${translate("Order")} #: `}
                {!hasProgramItems && (
                    <Typography {...styles.orderNumberText} data-test-selector="orderConfirmation_orderNumber">
                        {cart.erpOrderNumber || cart.orderNumber}
                    </Typography>
                )}
            </Typography>
            {hasProgramItems && (
                <Typography {...styles.orderSplitText}>
                    {translate("Your order has been split into 2 orders.")}
                </Typography>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderConfirmationHeading),
    definition: {
        displayName: "Order Confirmation Heading",
        icon: "cart-circle-check",
        group: "Order Confirmation",
    },
};

export default widgetModule;
